<template>
<div class="footer-container" v-if="mainData">
    <div class="footer-center">
        <div class="footer-content-container">
            <div class="footer-content">
                <img src="../../../static/image/logo2.png"/>
                <span v-if="mainData.address">公司地址：{{mainData.address}}</span>
                <span v-if="mainData.phone">联系方式：{{mainData.phone}}</span>
                <span v-if="mainData.email">邮箱：{{mainData.email}}</span>
            </div>
            <div class="wx-public">
                <img src="../../../static/image/wx_public_qr.png"/>
                <span>微信公众号</span>
            </div>
            <div class="wx-mini">
                <img src="../../../static/image/mini_qr.png"/>
                <span>小程序</span>
            </div>
        </div>
        <div class="footer-tips">
            <div style="color: #FFFFFF;
            font-size: 14px;"><img style="width: 16px;height: 16px;" src="../../../static/image/gongan.png"/>&ensp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602104564" target="_blank" style="color: #FFFFFF;font-size: 14px;">京公网安备11010602104564</a>&ensp;&ensp;&ensp;&ensp;<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #FFFFFF;font-size: 14px;">备案号：京ICP备19001101号</a></div>
            <div style="height: 10px;"></div>
            <div style="color: #FFFFFF;font-size: 14px;">增值电信业务经营许可证编号：京B2-20214388&ensp;&ensp;&ensp;&ensp;互联网药品信息服务资格证书编号：(京)-经营性-2022-0038</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      mainData:null
    }
  },
  created() {
    this.wjtHttp.get(this,'/api/home/v1/info',{},false,(res)=>{
            var data = res.data
            if(data.code == 200){
              this.mainData = data.data
            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'信息获取异常，请联系管理员',
                    type:'error'
                })
            }
        })
  }
}
</script>

<style scoped>
.footer-container{
    background: #414141;
    width: 1366px;
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer-center{
    width: 1160px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer-content-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 37px;
}
.footer-content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width:50%;
}
.footer-content>img{
    width: 117px;
    height: 40px;
}
.footer-content>span{
    font-size: 16px;
    color: #FFFFFF;
    text-align: left;
    margin-top: 10px;
}
.wx-public{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    left:calc(50% - 296px)
}
.wx-public>img{
    width:100px;
    height: 100px;
}
.wx-public>span{
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 18px;
}
.wx-mini{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    left:calc(50% - 260px);
}
.wx-mini>img{
    width:100px;
    height: 100px;
}
.wx-mini>span{
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 18px;
}
.footer-tips{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
}
.footer-tips>span{
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Footer.vue